import { MuiThemeProvider } from '@material-ui/core';
import { getPersistor } from '@rematch/persist';
import { ConnectedRouter } from 'connected-react-router';
import React, { useEffect, useMemo, useState } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ThemeProvider } from 'styled-components';
import {
    PATH_ORDERS,
    PATH_ROOT,
    PATH_SIGN_IN,
    PATH_ORDER_NEW,
    PATH_ORDERS_ARCHIVE,
    PATH_STOCK,
    PATH_STOCK_PALLET,
    PATH_ORDER_EDIT,
} from '../../../constants/routerPaths';
import { history, store } from '../../../store/store';

//import ToastContainers from "../../presentational/toast-containers/ToastContainers";

import { PrivateMenuRoute } from '../private-route/PrivateMenuRoute';

import 'react-toastify/dist/ReactToastify.css';
import 'fulogics-ui-web/dist/index.css';
import 'fulogics-ui-web/dist/layout/styles/fulogics.main.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'fulogics-ui-web/dist/layout/styles/dx.material.Fulogics-theme-01.css';
import 'fulogics-ui-web/dist/layout/styles/dx.fulogics.theme.css';
import 'fulogics-ui-web/dist/layout/styles/dx.loadIndicator.css';
import 'semantic-ui-css/semantic.min.css';
import 'fulogics-ui-web/dist/index.css';

import styles from './AppScreen.module.scss';
//
import DashboardScreen from '../dashboard-screen/DashboardScreen';
import { LoginScreen } from '../login-screen/LoginScreen';
import { OrderNewScreen } from '../order-new-sceen/OrderNewScreen';
import { OrdersArchiveScreen } from '../orders-archive-screen/OrdersArchiveScreen';
import { OrdersScreen } from '../orders-screen/OrdersScreen';
import { StockScreen } from '../stock-screen/StockScreen';
import { PalletStockScreen } from '../pallet-stock-screen/PalletStockScreen';
import materialUiTheme from '../../styles/createThemeMaterialUi';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../../translations/i18n';
import { InspectorContext } from 'fulogics-ui-web/dist/layout/inspector/context/InspectorContext';
import { Singleton } from 'fulogics-ui-core/dist/Singleton';
import { ITemplateProps } from 'devextreme-react/core/template';
import { Template } from 'devextreme-react';
import ToastContainers from 'fulogics-ui-web/dist/layout/components/toast-containers/ToastContainers';
//import InspectorContextProvider from "fulogics-ui-web/dist/layout/inspector/context/InspectorContext";
import { DraggableModalProvider } from 'ant-design-draggable-modal';
import { OrderEditScreen } from '../order-edit-screen/OrderEditScreen';
import { PrivateRoute } from '../private-route/PrivateRoute';
import {
    coreTemplates,
    LayoutTemplatesContext,
} from 'fulogics-ui-web/dist/layout/layout-control/LayoutTemplatesContext';
import InspectorOptionsStoreContext from 'fulogics-ui-web/dist/layout/inspector/context/InspectorOptionsStoreContext';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { UIWebConfigContext } from 'fulogics-ui-web/dist/config/UIWebConfigContext';
import { UIWebDefaultConfig } from 'fulogics-ui-web/dist/config/UIWebDefaultConfig';
import { UIConfigContext, UiConfig } from '../../../UIConfig';
import { theme } from '../../styles/theme';

const persistor = getPersistor();

// @ts-ignore
Singleton.dxTemplateFactoryHacks = (props: ITemplateProps) => <Template {...props} />;

const layoutTemplates = {
    templates: {
        ...coreTemplates,
    },
};

const UIWebConfig = {
    ...UIWebDefaultConfig,
    orderLock: {
        totalInterval: 60 * 10,
        visibleInterval: 60 * 2,
    },
};

export default function AppScreen() {
    {
        /*<ToastContainers/>
                            <NotificationsScreenContainer/>
                            <LoaderContainer/>*/
    }
    useEffect(() => {
        // @ts-ignore
        store.dispatch.Identity.refreshUserProfile();
    }, []);

    const [disabled, setDisabled] = useState(true);
    const value = useMemo(() => ({ disabled, setDisabled }), [disabled]);

    try {
        return (
            <div className={styles.appContainer}>
                <I18nextProvider i18n={i18n}>
                    <MuiThemeProvider theme={materialUiTheme}>
                        <UIConfigContext.Provider value={UiConfig}>
                            <ThemeProvider theme={theme}>
                                <UIWebConfigContext.Provider value={UIWebConfig}>
                                    <Provider store={store}>
                                        <InspectorOptionsStoreContext.Provider value={propsStore}>
                                            <LayoutTemplatesContext.Provider
                                                value={layoutTemplates}
                                            >
                                                <DraggableModalProvider>
                                                    <ToastContainers />
                                                    {/*@ts-ignore*/}
                                                    <InspectorContext.Provider value={value}>
                                                        {/*<PersistGate loading={null} persistor={persistor}>*/}
                                                        {/* TODO: w przyszłości będzie trzeba przenieść routy do innego komponentu  */}
                                                        <ConnectedRouter history={history}>
                                                            <Switch>
                                                                <PrivateMenuRoute
                                                                    exact
                                                                    component={DashboardScreen}
                                                                    path={PATH_ROOT}
                                                                />
                                                                <PrivateMenuRoute
                                                                    exact
                                                                    path={PATH_STOCK}
                                                                    component={StockScreen}
                                                                />
                                                                <PrivateMenuRoute
                                                                    exact
                                                                    path={PATH_STOCK_PALLET}
                                                                    component={PalletStockScreen}
                                                                />
                                                                <PrivateMenuRoute
                                                                    exact
                                                                    path={PATH_ORDERS}
                                                                    component={OrdersScreen}
                                                                />
                                                                <PrivateMenuRoute
                                                                    exact
                                                                    path={PATH_ORDER_NEW}
                                                                    component={OrderNewScreen}
                                                                />
                                                                <PrivateRoute
                                                                    exact
                                                                    path={PATH_ORDER_EDIT}
                                                                    component={OrderEditScreen}
                                                                />
                                                                <PrivateMenuRoute
                                                                    exact
                                                                    path={PATH_ORDERS_ARCHIVE}
                                                                    component={OrdersArchiveScreen}
                                                                />
                                                                <PrivateMenuRoute
                                                                    component={() => (
                                                                        <label>
                                                                            Not found route
                                                                        </label>
                                                                    )}
                                                                />
                                                                <Route
                                                                    path={PATH_SIGN_IN}
                                                                    component={LoginScreen}
                                                                />
                                                            </Switch>
                                                        </ConnectedRouter>
                                                        {/*</PersistGate>*/}
                                                    </InspectorContext.Provider>
                                                </DraggableModalProvider>
                                            </LayoutTemplatesContext.Provider>
                                        </InspectorOptionsStoreContext.Provider>
                                    </Provider>
                                </UIWebConfigContext.Provider>
                            </ThemeProvider>
                        </UIConfigContext.Provider>
                    </MuiThemeProvider>
                </I18nextProvider>
            </div>
        );
    } catch (error) {
        console.error(error);
        throw error;
    }
}
